var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',{staticClass:"mainheader"},[_c('div',{staticClass:"left"},[_vm._v("Mini Program JDT 2021")]),_c('div',{staticClass:"right"},[_vm._v(_vm._s(_vm.time))])]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }